
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What is the I Say I Am app?',
      answer: 'I Say I Am is a daily affirmations, reflection, and gratitude system designed to help you build a stronger mindset and inner clarity. It combines identity-based affirmations, guided reflection prompts, and gratitude journaling in one simple, grounded practice.'
    },
    {
      question: 'Do I have to journal every day?',
      answer: 'Not at all. The system is designed to be flexible. You can use it daily for consistency, or a few times a week when you need it most. There is no pressure-just show up when it feels right for you.'
    },
    {
      question: 'Are the affirmations religious or neutral?',
      answer: 'The affirmations are completely neutral and secular. They focus on identity, mindset, and personal growth without any religious or spiritual doctrine. They are designed to be inclusive and accessible to everyone.'
    },
    {
      question: 'Can I use it without the app?',
      answer: 'Yes. We offer printable cards, journals, and worksheets for people who prefer writing on paper. The app is just one way to access the practice-you can choose what works best for your lifestyle.'
    },
    {
      question: 'How long does a daily practice take?',
      answer: 'Most people spend 3-10 minutes per session. You can read an affirmation in 30 seconds, or spend longer with reflection prompts and journaling. It is designed to fit into real life, not take over your morning.'
    },
    {
      question: 'Is this for beginners or experienced practitioners?',
      answer: 'Both. If you are new to affirmations or journaling, the system guides you step-by-step. If you already have a practice, it provides structure and depth to deepen your work. It meets you where you are.'
    },
    {
      question: 'What makes this different from other affirmation apps?',
      answer: 'We focus on identity-based "I am" statements rather than surface-level positivity. The system combines affirmations with reflection and gratitude for a complete practice. And the tone is grounded, mature, and practical-no fluff or toxic positivity.'
    }
  ];

  return (
    <section id="faq" className="bg-white py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-4">
            Questions?
          </h2>
          <div className="w-20 h-1 bg-[#FFB8B8] rounded-full mx-auto" style={{ clipPath: 'ellipse(50% 100% at 50% 0%)' }}></div>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-0">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`border-b border-gray-200 py-6 transition-colors ${
                index % 2 === 0 ? 'bg-transparent' : 'bg-[#FDFBF7]'
              } px-6 hover:bg-[#FAF8F5] cursor-pointer`}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              {/* Question */}
              <div className="flex items-center justify-between">
                <h3 className="text-lg lg:text-xl font-semibold text-[#2C2C2C] pr-8">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                  <i
                    className={`${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    } text-2xl text-[#2C2C2C] transition-all duration-300 ${
                      openIndex === index ? 'text-[#FFB8B8]' : ''
                    }`}
                  ></i>
                </div>
              </div>

              {/* Answer */}
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100 mt-8' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="text-base text-[#5A5A5A] leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
